export default {"src":"/_next/static/media/rates.2eeb063d.svg","height":120,"width":121};